import React from "react";

import "./css_icon.css";

import * as Icons from './IconsList';

const Icon = props => {

  let customStyle = props.style || "";
  let tempIcon = props.iconName
    .split("-")
    .map(item => item.charAt(0).toUpperCase() + item.substring(1))
    .join("");
  tempIcon = tempIcon
    .split("_")
    .map(item => item.charAt(0).toUpperCase() + item.substring(1))
    .join("");
  tempIcon = tempIcon
    .split(" ")
    .map(item => item.charAt(0).toUpperCase() + item.substring(1))
    .join("");

  return (
    <div className={"Ui_icon " + customStyle}>
      <img src={Icons[tempIcon]} alt={props.iconName} />
    </div>
  );
};

export default Icon;

